import React, { memo, useEffect, useRef, useState } from 'react';
import { useMobileOrientation } from 'react-device-detect';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation } from 'swiper';
import ReactPlayer from 'react-player';

import {
  DEMO_USER_PICTURE,
  placeDemoUserPicture,
  reactHtmlParser,
  specialityPopOver
} from '../../../common/common';
import { CLICK_CARD } from '../../../TrackerFolder/constants/ActionType';
import { onCardClick } from '../../../TrackerFolder/actions';
import useRedirect from '../../../components/customHooks/useRedirect';
import { useTracker } from '../../../TrackerFolder/TrackerComponent';
// import ReactHtmlParser from 'react-html-parser';
import ShareButton from '../../../components/ShareButton';
import LazyImage from '../../../components/CustomLibraries/LazyImage';
import { useTrackUserActivity } from '../../../components/customHooks/useTrackUserActivity';
import InView from 'react-intersection-observer';

const ClinicalHeroCard = ({ _video, _idx, activeIdx }) => {
  const playerRef = useRef();
  const { isLandscape } = useMobileOrientation;
  const videoDetailsParent = useRef();
  const { redirectTo } = useRedirect();
  const { trackActivityEvent } = useTracker();
  const [aspectVideoContainerSize, setAspectVideoContainerSize] = useState('0px');
  const onPlay = (_idx, playedTime) => {
    if (_idx == activeIdx && playedTime && playerRef.current) {
      playerRef.current?.seekTo(playedTime, 'seconds');
    }
  };
  const setVideoConatinerSize = () => {
    if (videoDetailsParent.current) {
      const videoDivWidth = videoDetailsParent.current ? videoDetailsParent.current.clientWidth : 0;
      const aspectWidth = videoDivWidth / 1.7786;
      setAspectVideoContainerSize(aspectWidth > 0 ? Math.round(aspectWidth) : 0);
      console.log('aspect size is' + aspectWidth);
    }
  };
  useEffect(() => {
    setVideoConatinerSize();
  }, [isLandscape]);

  const { userActivityTracker } = useTrackUserActivity();

  return (
    <>
      <InView
        as="div"
        onChange={(inView) => {
          userActivityTracker(inView, { ..._video, type: 'archived_video' }, 'card');
        }}
      >
        <div className="clinicalFeaturedTag fs-4 fw-medium text-white bg-secondary py-2 px-5 position-absolute">
          Featured
        </div>
      </InView>

      <div
        className="col-xl-8 col-lg-7 col-md-7 col-12 clinicalFeaturedRight bg-black p-0"
        ref={videoDetailsParent}
        style={{ height: `${aspectVideoContainerSize}px` }}
      >
        <ReactPlayer
          ref={playerRef}
          onStart={() => onPlay(_idx, _video.play_time)}
          width={'100%'}
          url={_video?.src}
          controls={true}
          muted={true}
          playing={_idx == activeIdx}
          playsinline={true}
          vimeoConfig={{
            iframeParams: { fullscreen: 0 }
          }}
        />
      </div>

      <div className="col-xl-4 col-lg-5 col-md-5 col-12 clinicalFeaturedLeft text-start p-3 p-md-4 pt-md-70 px-lg-20 pb-5 pb-md-5 position-relative">
        <Swiper
          className="clinicalFeaturedSponser mb-3 m-md-0 text-end position-absolute"
          navigation={false}
          spaceBetween={0}
          slidesPerView={1}
          loop={true}
          autoplay={{
            delay: 2500
          }}
          effect={'fade'}
        >
          {_video?.sponsor_logo?.split(',')?.map((_sp, index) => (
            <SwiperSlide
              className="clinicalFeaturedSponserIn bg-white position-relative w-100"
              key={index + 1}
            >
              <LazyImage
                src={_sp}
                className="position-absolute top-50 end-0 translate-middle-y mw-100 mh-100 w-auto h-auto"
                alt="Sponsor"
                logo
              />
            </SwiperSlide>
          ))}
        </Swiper>
        <span className="text-black clinicalFeaturedSplty position-relative pb-2 mb-3 d-flex gap-2">
          <span
            className="fs-4 cursorPointer gtm_cl_clinical_videos_landing_featured_card_speciality"
            onClick={() => {
              if (_video?.specialities_ids_and_names) {
                redirectTo(
                  'Speciality',
                  _video?.specialities_ids_and_names[0]?.id,
                  _video?.specialities_ids_and_names[0]?.name
                );
              }
            }}
          >
            {_video?.specialities?.split(',')[0]}
          </span>
          {specialityPopOver(_video?.specialities)}
        </span>
        <h2
          className="fs-3 text-black fw-medium mb-2 cursorPointer gtm_cl_clinical_videos_landing_featured_card"
          onClick={
            () => {
              trackActivityEvent(CLICK_CARD, onCardClick(_video.type_id, 'Clinical Video'));
              redirectTo('ClinicalVideoDetails', _video.type_id, _video.question);
            }
            // navigate(
            //   `/ClinicalVideoDetails?id=${_video.type_id}`
            // )
          }
        >
          {reactHtmlParser(_video.question)}
        </h2>
        <p
          className="fs-4 cursorPointer mb-0 gtm_cl_clinical_videos_landing_featured_card line-clamp-2"
          onClick={
            () => {
              trackActivityEvent(CLICK_CARD, onCardClick(_video.type_id, 'Clinical Video'));
              redirectTo('ClinicalVideoDetails', _video.type_id, _video.question);
            }
            // navigate(
            //   `/ClinicalVideoDetails?id=${_video.type_id}`
            // )
          }
        >
          {reactHtmlParser(_video.answer)}
        </p>
        <div className="w-100 clinicalFeaturedDoctor mt-3 mb-20">
          <Swiper spaceBetween={0} slidesPerView={1} loop={false} navigation={true}>
            {_video.session_doctor_entities?.map((_doc, index) => (
              <SwiperSlide
                className="clinicalFeaturedDoctorBox text-start"
                key={index + 1}
                onClick={() => {
                  if (_doc?.session_doctor_id) {
                    redirectTo(
                      'SpeakerProfile',
                      _doc?.session_doctor_id,
                      _doc?.session_doctor_name
                    );
                  }
                }}
              >
                <div className="w-100 clinicalFeaturedDoctorBoxIn pe-4 d-flex justify-content-between align-items-center">
                  <div className="clinicalFeaturedDoctorPic position-relative overflow-hidden border border-white rounded-circle">
                    <LazyImage
                      src={_doc?.session_doctor_image}
                      className="object-fit-cover w-100 h-100 float-start gtm_cl_clinical_videos_landing_featured_card"
                      fallback_image={DEMO_USER_PICTURE}
                      alt={_doc?.session_doctor_name}
                      logo
                    />
                  </div>
                  <div className="clinicalFeaturedDoctorContent ps-3">
                    <h4 className="text-black fs-4 fw-medium gtm_cl_clinical_videos_landing_featured_card">
                      {_doc?.session_doctor_name}
                    </h4>
                    <p className="text-dark fs-4 gtm_cl_clinical_videos_landing_featured_card">
                      {_doc?.DepartmentName}
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="d-flex">
          <ShareButton
            data={{
              title: _video.question,
              url: _video.deeplink
            }}
            customClass={
              'btn btn-primary fs-3 fw-medium rippleEffect rounded clinicalFeaturedShare py-3 px-4 d-flex aling-items-center justify-content-center'
            }
            gtmTagVariable="gtm_cl_clinical_videos_landing_featured_card_share"
          />
          <a
            className="btn btn-secondary fs-4 fw-medium rippleEffect rounded clinicalFeaturedShare ms-3 py-3 px-4 d-flex aling-items-center justify-content-center gtm_cl_clinical_videos_landing_featured_card"
            href="javascript:void(0)"
            onClick={
              () => {
                trackActivityEvent(CLICK_CARD, onCardClick(_video.type_id, 'Clinical Video'));
                redirectTo('ClinicalVideoDetails', _video.type_id, _video.question);
              }
              // navigate(
              //   `/ClinicalVideoDetails?id=${_video.type_id}`
              // )
            }
          >
            View
            <i className="flaticon-next fs-4 ms-2 gtm_cl_clinical_videos_landing_featured_card d-flex align-items-center"></i>
          </a>
        </div>
      </div>
    </>
  );
};
export default memo(ClinicalHeroCard);
